const MULTIPLE_FIELD_REPORT_AI_SUMMARY_CLICKED = 'AI Summarization Clicked - Multiple Reports';
const SINGLE_FIELD_REPORT_AI_SUMMARY_CLICKED = 'AI Summarization Clicked - Single Report';

const fieldReportAnalyticsConstants = {
  MULTIPLE_FIELD_REPORT_AI_SUMMARY_CLICKED,
  SINGLE_FIELD_REPORT_AI_SUMMARY_CLICKED,
};

export default fieldReportAnalyticsConstants;
